import parse from 'html-react-parser';
import styles from './cardWithTitle.module.scss';
import CardItem from '../checkYourRateCard/checkYourRateCard';

export default function CardWithTitle({ title, card }) {
  return (
    <div className={styles.cardWithTitleWrapper}>
      <div className={styles.title}>{parse(title)}</div>
      <CardItem {...card} />
    </div>
  );
}
